import React from 'react';
import { motion } from 'framer-motion';

const publicUrl = process.env.PUBLIC_URL || '';

const clients = [
  { name: 'NAPSA', image: `${publicUrl}/images/napsa.png` },
  { name: 'Longhorn', image: `${publicUrl}/images/longhorn1.png` },
  { name: 'Richmond', image: `${publicUrl}/images/richmond.png` },
  { name: 'Monter Capital Partnership Limited', image: `${publicUrl}/images/Monter.png` },
  { name: 'MyBucks Zambia', image: `${publicUrl}/images/mybucks.png` },
  { name: 'City Drive', image: `${publicUrl}/images/city.jpg` },
  { name: 'Savanna Insurance Brokers Ltd.', image: `${publicUrl}/images/savana.png` },
  { name: 'Brian Malambo Foundation', image: `${publicUrl}/images/brian.png` },
  { name: 'Sisabelo Saka Inclusive School', image: `${publicUrl}/images/sisabelo.png` },
  { name: 'Tiye', image: `${publicUrl}/images/tiye.png` },
  { name: 'Longhorn Capital Partners', image: `${publicUrl}/images/longhorn-capital.png` },
  { name: 'Longhorn Construction', image: `${publicUrl}/images/longhorn-construction.png` },
];

export default function Clients() {
  return (
    <section id="clients" style={{ padding: '8rem 2rem' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: 'center', marginBottom: '4rem' }}
        >
          <span style={{
            display: 'inline-block', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.14em',
            textTransform: 'uppercase', color: 'var(--text)', marginBottom: '1rem',
            padding: '0.3rem 0.9rem', borderRadius: 100,
            background: 'var(--electric-dim)', border: '1px solid var(--gray-light)',
          }}>Trusted By</span>
          <h2 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.75rem)', letterSpacing: '-0.02em', color: 'var(--text)' }}>
            Our <span style={{ color: 'var(--orange)' }}>Clients</span>
          </h2>
          <p style={{ fontSize: '1rem', color: 'var(--text-soft)', marginTop: '1rem' }}>
            Organizations across Zambia trust Findura to power their digital infrastructure.
          </p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
          {clients.map((client, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07, duration: 0.4 }}
              style={{
                padding: '1.5rem',
                background: 'rgba(255,255,255,0.5)',
                border: '1px solid var(--gray-light)',
                borderRadius: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem',
                cursor: 'default',
                transition: 'border-color 0.3s',
                height: 120,
                userSelect: 'none',
                WebkitUserSelect: 'none',
              }}
            >
              <img 
                src={client.image} 
                alt={client.name}
                style={{
                  maxWidth: '90%',
                  maxHeight: '90%',
                  objectFit: 'contain',
                }}
                title={client.name}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
